import { useEffect } from "react"
import { useSelector } from "react-redux"
import { RootState } from "../../../../mp-core/redux/store"
import { Educator } from "../../../../mp-database"
import { GlobalMachineContext } from "../../../study-plans/pages/StudyPlansInit/StudyPlansInit"
import { getStudyPlanScopeByUserRole } from "../../../study-plans/helpers"

export const useUserInitialSetup = () => {
  const { user } = useSelector((state: RootState) => ({
    user: state.users.testUser as Educator
  }))
  const { send } = GlobalMachineContext.useActorRef()

  useEffect(() => {
    if (!user) return
    send({
      type: "SELECT_USER",
      newRole: getStudyPlanScopeByUserRole(user.role),
      newDistrictId: user.schoolDistrict,
      newTeacherId: user.isTeacher ? user.id : null,
      newSchoolId: user.school
    })
  }, [user])
}
